/**
 *
 * PreviewMedia
 *
 */

import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { saveAs } from 'file-saver';

import { STORAGE_BUCKET_URL } from 'utils/constants.js';

// styles
import './style.scss';

// assets
import { CloseOutlined, EyeOutlined } from '@ant-design/icons';
import CustomIcons from 'components/CustomIcons';
import HiddenField from 'components/Forms/Fields/HiddenField';
// utils
import { slugify } from 'utils/helpers/helper.general';

function PreviewMedia({
  file,
  title,
  showTitle,
  icon,
  showIcon,
  showIconPreview,
  showInput,
  prevStep,
  remove,
  name,
  // default props
  className,
}) {
  const childClassNames = classNames('preview-media', className);

  let fileName = '';
  if (!!file && typeof file === 'string') {
    fileName = STORAGE_BUCKET_URL
      ? file.replace(STORAGE_BUCKET_URL + '/', '')
      : file;
  } else if (!!file && typeof file === 'object') {
    fileName = file?.name;
  }

  const openFileViewer = useCallback(() => {
    //  setOpen(!isOpen);
    file && saveAs(file, slugify(fileName));
  }, [file]);

  return (
    !!file && (
      <div className={childClassNames}>
        {showTitle && <h3 className="preview-title">{title}</h3>}
        <div className="preview-file">
          <div className="file-backround" onClick={openFileViewer}>
            {showIcon && (
              <CustomIcons className="file-icon" type={icon} />
            )}
            <span className="file-name">{fileName}</span>
          </div>
          {showIconPreview && (
            <EyeOutlined className="file-view" onClick={openFileViewer} />
          )}
          {remove !== undefined && (
            <CloseOutlined
              className="file-delete"
              onClick={() => {
                remove(file);
              }}
            />
          )}
        </div>
        {showInput && (
          <HiddenField data={{ name: name }} value={file} index={0} />
        )}
      </div>
    )
  );
}

PreviewMedia.defaultProps = {
  name: 'preview-media',
  showTitle: true,
  showIcon: true,
  showIconPreview: true,
  canRemode: true,
  title: 'Justificatif',
  icon: 'proof-document',
  showInput: false,
};
PreviewMedia.propTypes = {
  title: PropTypes.string,
  showTitle: PropTypes.bool,
  remove: PropTypes.func,
};

export default memo(PreviewMedia);
